import { Field, useField } from 'react-final-form';
import { useVideoUrl } from '../CameraView/hooks/useVideoUrl';
import { PhotosWrapper } from './ui';
import { FieldArray } from 'react-final-form-arrays';
import { EmptyImage, EmptyImageWithUpload, PhotoComponent } from '../components/photos';
import { VideoComponent } from './VideoComponent';
import { EmptyVideoComponent } from '../components/photos/VideoUpload';

type DefaultPhotosListProps = {
  sectionId: string;
  background: string;
};

const obdSectionPath = 'interior_questions.subsections.odb_check_smog_readiness';

export const localRemove = (fields: any, i: number) => {
  if (fields.value[i] && fields.value[i].type) {
    fields.update(i, { ...fields.value[i], url: '', url_thumb: '', local_url: '' });
  } else {
    fields.remove(i);
  }
};

export const DefaultPhotosList = ({ sectionId, background }: DefaultPhotosListProps) => {
  const {
    input: { value: video }
  } = useField(`${sectionId}.video`);
  const videoUrl = useVideoUrl(video);

  const showVideoPlaceholder = !videoUrl && sectionId.endsWith('exterior');

  return (
    <PhotosWrapper style={{ background }}>
      {sectionId === 'under_hood' && <RenderPhotos sectionId={obdSectionPath} />}
      <RenderPhotos sectionId={sectionId} />
      <EmptyImageWithUpload sectionId={sectionId} />
      {showVideoPlaceholder && <EmptyVideoComponent />}
      {videoUrl && <VideoComponent sectionId={sectionId} url={videoUrl} />}
    </PhotosWrapper>
  );
};

type RenderPhotosProps = {
  sectionId: string;
};

const RenderPhotos = ({ sectionId }: RenderPhotosProps) => {
  return (
    <FieldArray name={`${sectionId}.images`}>
      {({ fields }) =>
        fields.map((name, i) => (
          <Field
            key={name}
            name={name}
            // component={PhotoRenderComponent}
            render={props => (
              <PhotoComponent
                localRemove={() => localRemove(fields, i)}
                withUploadLabel={false}
                displaySize="md"
                {...props}
              />
            )}
          />
        ))
      }
    </FieldArray>
  );
};
